export enum ValidationStates {
  Success = 'Success',
  Error = 'Error',
  None = 'None'
}
